<template>
    <el-form :model="formData" label-width="100px">
        <el-row>
			<el-col :span="7" class="col-h">
                <el-form-item label="出价方式" prop="way" required >
                    <el-select v-model="formData.way" @change="handleChange"> 
                        <el-option 
                            v-for="item in global.priceTypeList" 
                            :label="item.label" 
                            :value="item.value"
                            :key="item.value"
                        />
                    </el-select>
                </el-form-item>
            </el-col>
            <el-col v-if="formData.way && strategyList" :span="7"  class="col-h">
				<el-form-item label="投放策略" prop="strategy" required>
					<el-select v-model="formData.strategy" >
						<el-option 
							v-for="item in strategyList" 
							:label="item.label" 
							:key="item.label"
                            :value="item.value"
						/>
					</el-select>
				</el-form-item>
			</el-col>
            <slot v-if="formData.way"/>
        </el-row>
    </el-form>
</template>

<script>
import _ from 'lodash';
export default {
    name: 'CommonForm',
    inject: [ 'global', 'formData', 'defaultFormData' ],
    props: {
		strategyList: {
			type: Array,
			default: ()=> null
		}
	},
    data() {
        return {
        }
    },
    methods: {
        handleChange(value) {
            this.$set(this.formData, 'strategy', '');
            Object.keys( _.omit(this.defaultFormData, ['way'])).forEach(key => {
                this.$set(this.formData, key, this.defaultFormData[key])
            });
            this.global.appList.forEach(item=> {
                this.$set(this.formData, item.value, '')
                this.$set(this.formData, `deep_${item.value}`, '')
                this.$set(this.formData, `type_${item.value}`, '')
            })
        },
    }
}
</script>
<style>
.col-h {
	min-height: 52px;
}
</style>
<style lang="scss" scoped>

</style>